import { TranslationSet } from './en';

export const fr: Partial<TranslationSet> = { // TODO: Remove `Partial`
  Sites: 'Emplacements',
}
